import type { TFunction } from 'i18next';
import type { FooterMenuLabels } from './footerNavigation';

/**
 * The footer's translated copy, from whichever `t` the caller has: the SPA Footer's
 * (useTranslation) or the server's (rsc/i18n.ts, for rsc/root.tsx). FooterBody takes it as props.
 *
 * Keys are spelled out in full at each `t()` call so `npm run i18n:check` can find them.
 */
export interface FooterStrings {
    partnership: string;
    /** Title of the links to the partners page. */
    partnersLinkTitle: string;
    logos: {
        britebound: string;
        jff: string;
        kuder: string;
    };
    /** The footer nav landmark's name. */
    navLabel: string;
    menus: {
        resources: FooterMenuLabels;
        legal: FooterMenuLabels;
    };
    contact: string;
    disclaimer: string;
    /** One sentence; `<1>` marks the Twemoji link and `<2>` the licence link (see renderTagged). */
    twemojiCredit: string;
}

export function footerStrings(t: TFunction): FooterStrings {
    return {
        partnership: t('footer.partnership'),
        partnersLinkTitle: t('footer.partnersLinkTitle'),
        logos: {
            britebound: t('footer.logos.britebound'),
            jff: t('footer.logos.jff'),
            kuder: t('footer.logos.kuder'),
        },
        navLabel: t('footer.navLabel'),
        menus: {
            resources: {
                menu: t('footer.menus.resources.label'),
                items: {
                    faqs: t('footer.menus.resources.items.faqs'),
                    glossary: t('footer.menus.resources.items.glossary'),
                    changelog: t('footer.menus.resources.items.changelog'),
                    partnersAndVendors: t('footer.menus.resources.items.partnersAndVendors'),
                },
            },
            legal: {
                menu: t('footer.menus.legal.label'),
                items: {
                    privacyPolicy: t('footer.menus.legal.items.privacyPolicy'),
                    termsOfUse: t('footer.menus.legal.items.termsOfUse'),
                    cookieSettings: t('footer.menus.legal.items.cookieSettings'),
                },
            },
        },
        contact: t('footer.contact'),
        disclaimer: t('footer.disclaimer'),
        twemojiCredit: t('footer.twemojiCredit'),
    };
}
